import type { DatoveSchrankyDatovaZpravaDto } from '@gov-nx/api';

export const isUnreadMessage = (message: DatoveSchrankyDatovaZpravaDto) =>
	message.statusDz !== '7' && message.statusDz !== null;
